import { Fragment } from "react";

import RightArrowIcon2 from "~/icons/RightArrow2Icon";
import { classNames } from "~/utils/utils";
import { IBreadcrumbItem, itemsToRenderItems } from "~/utils/breadcrumbs";

import "./style.less";

interface IBreadCrumbs {
	items: Array<string | IBreadcrumbItem>;
}

export default function BreadCrumbs({
	items = [],
}: IBreadCrumbs) {
	const renderItems: Array<IBreadcrumbItem> = items.length > 0
		? typeof items[0] === "string"
			? itemsToRenderItems(items as Array<string>)
			: items as Array<IBreadcrumbItem>
		: [];

	/* eslint-disable react/no-array-index-key */
	return <div className="breadcrumbs">
		{ renderItems.map((item, ind) => <Fragment key={ind}>
			{ item.type === "text" && <span className={classNames(["breadcrumbs__item", item.className])} style={ item.style }>
				{ item.value }
			</span> }
			{ item.type === "separator" && <span className="breadcrumbs__separator">
				<RightArrowIcon2 />
			</span> }
		</Fragment>) }
	</div>;
}
